import { SUBJECT_CONFIG, type SubjectCode } from '../utils/subjectConfig';

type SubjectBadgeProps = {
  subject: SubjectCode;
  size?: 'sm' | 'md';
};

export function SubjectBadge({ subject, size = 'md' }: SubjectBadgeProps) {
  const config = SUBJECT_CONFIG[subject];
  const dim = size === 'sm' ? 20 : 24;
  const fontSize = size === 'sm' ? 11 : 13;

  return (
    <span
      className="inline-flex shrink-0 items-center justify-center font-bold text-white"
      style={{
        width: dim,
        height: dim,
        borderRadius: 5,
        backgroundColor: config.color,
        fontSize,
      }}
      aria-hidden
    >
      {config.char}
    </span>
  );
}
